import { mcn } from "@/utils";

interface Props {
  tabs: {
    text: string;
  }[];
  selectedIndex: number;
  onTabClick: (index: number) => void;
}

export function NavigationTabs(props: Props) {
  return (
    <div className="flex gap-x-4">
      {props.tabs.map((tab, index) => (
        <button
          key={index}
          className="text-grey-20 flex-shrink-0"
          onClick={() => props.onTabClick(index)}
        >
          <span
            className={mcn(
              "text-style-subtitle1 border-b-2 hover:border-red-100",
              props.selectedIndex === index
                ? "border-red-100 text-white"
                : "border-[transparent] text-grey-20"
            )}
          >
            {tab.text}
          </span>
        </button>
      ))}
    </div>
  );
}
